import { render } from "./CommentaryMentions.vue?vue&type=template&id=396b18db&ts=true"
import script from "./CommentaryMentions.vue?vue&type=script&lang=ts"
export * from "./CommentaryMentions.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__